<template>
  <div>
    <el-select v-model="areaIds[0]" :disabled="dis[0]" clearable @change="areaChange($event,0)" placeholder="省" style="margin-bottom: 18px;">
      <el-option v-for="(x,i) in areaArrs.province" :key="i" :label="x.name" :value="x.id"></el-option>
    </el-select>
    <el-select v-model="areaIds[1]" :disabled="dis[1]" clearable @change="areaChange($event,1)" placeholder="市" style="margin: 0 0 18px 20px;">
      <el-option v-for="(x,i) in areaArrs.city" :key="i" :label="x.name" :value="x.id"></el-option>
    </el-select>
    <br />
    <el-select v-model="areaIds[2]" :disabled="dis[2]" clearable @change="areaChange($event,2)" placeholder="区、县" style="margin-bottom: 18px;">
      <el-option v-for="(x,i) in areaArrs.county" :key="i" :label="x.name" :value="x.id"></el-option>
    </el-select>
    <el-select v-model="areaIds[3]" :disabled="dis[3]" clearable @change="areaChange($event,3)" placeholder="乡、镇" style="margin: 0 0 18px 20px">
      <el-option v-for="(x,i) in areaArrs.town" :key="i" :label="x.name" :value="x.id"></el-option>
    </el-select>
    <br />
    <el-select v-model="areaIds[4]" :disabled="dis[4]" clearable @change="areaChange($event,4)" placeholder="街道、村" style="margin-bottom: 18px;">
      <el-option v-for="(x,i) in areaArrs.village" :key="i" :label="x.name" :value="x.id"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: ['areaIdsChecked'],
  data() {
    return {
      mapList: ['province','city','county','town','village'],
      areaArrs: {
        province: [],
        city: [],
        county: [],
        town: [],
        village: [],
      },
      areaIds: [],
      dis: [],
    }
  },
  watch: {
    areaIdsChecked(nval, oval) {
      // console.log(nval, oval)
      this.replaceArea()
    }
  },
  methods: {
    replaceArea() {
      if (this.areaIdsChecked && this.areaIdsChecked.length > 0) {
        this.areaIds = JSON.parse(JSON.stringify(this.areaIdsChecked))
        this.areaIdsChecked.forEach((x, i) => { 
          this.getArea(i, x)
          // this.areaChange(x, i)
        })
      // } else {
      //   this.areaIds = []
      //   this.areaArrs.city = []
      //   this.areaArrs.county = []
      //   this.areaArrs.town = []
      //   this.areaArrs.village = []
      }
    },
    findAreaId() {
      let areaIdsArr = this.areaIds.filter(x => !!x)
      let areaId = areaIdsArr[areaIdsArr.length - 1]
      return areaId
    },
    findAreaNames() {
      let areaNames= []
      this.areaIds.forEach((x, i) => {
        let item = this.areaArrs[this.mapList[i]].find(x2 => x2.id === x)
        item.name ? areaNames.push(item.name) : ''
      })
      return areaNames
    },
    //选择某项时获取下一项的地点数据
    areaChange(areaId, index) {
      console.log(`%careaChange触发`, 'color: #00f;', index, areaId)
      this.areaIds.splice(index + 1)
      for (let j = index + 1; j < 5; j++) {
        this.areaArrs[this.mapList[j]] = []
      }
      this.getArea(index, areaId)
    },
    // 获取地理位置
    getArea(index, areaId) {
      console.log(`%cgetArea触发`, 'color: #00f;', index, areaId)
      if (index < 4) {
        let rD = { areaId }
        return this.$api.getPlace(rD).then(res => {
          if (res.data.status === 0 ) {
            let _R = JSON.parse(res.data.data)
            // console.log(_R)
            this.areaArrs[this.mapList[index + 1]] = _R
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c已经是最后的村级了`, 'color: #f00;')
      }
    },
    //设置默认地址
    getDefault() {
      let { admin, areaId } = this.userInfo
      if (admin) {
        for (let i = 0; i < 5; i++) { this.dis.push(false) }
      } else {
        return this.$api.getFather({ areaId }).then(res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            console.log(`%c默认地区:`, 'color: #00f;', _R)
            _R.forEach((x, i) => {
              this.areaIds[x.level] = x.id
              this.dis[x.level] = i !== 4
            })
            this.areaIds.forEach((x, i) => { 
              this.getArea(i, x)
            })
          } else { this._status(res.data) }
        })
      }
    },
    reset() {
      this.areaArrs = JSON.parse(JSON.stringify(this.areaArrs_x))
      this.areaIds = JSON.parse(JSON.stringify(this.areaIds_x))
      this.dis = JSON.parse(JSON.stringify(this.dis_x))
    },
  },
  async created() {
    // console.log(`%careaIds_x:`, 'color: #f00;', this.areaIds_x)
    if (this.userInfo) {
      if (this.userInfo.admin) {
        this.getArea(-1, '0')
      } else if (this.areaIds_x.length === 0) {
        this.getArea(-1, '0')
        await this.getDefault()
        this.$emit('getData')
      } else {
        this.areaArrs = JSON.parse(JSON.stringify(this.areaArrs_x))
        this.areaIds = JSON.parse(JSON.stringify(this.areaIds_x))
        this.dis = JSON.parse(JSON.stringify(this.dis_x))
        // console.log(
        //   this.areaArrs,
        //   this.areaIds,
        //   this.dis,
        //   this.areaIds[0]
        // )
        this.$emit('getData', this.findAreaId())
      }
      this.replaceArea()
    }
  },
}
</script>
